import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { extendObservable, computed } from 'mobx'
import moment from 'moment'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import CalendarIcon from '@components/Icon/Calendar'
import './MonthPicker.sass'
import MonthYearCalendar from './MonthYearCalendar'
import enhanceWithClickOutside from 'react-click-outside'

class MonthYearPicker extends Component {
  constructor(props) {
    super(props)

    extendObservable(this, {
      /*activeMonthAndYear: computed(() => {
        if (!this.props.monthAndYear) return ''
        if (this.props.monthAndYear && this.props.monthAndYear !== '') {
          return moment(this.props.monthAndYear).format('MMM YYYY')
        } else return ''
      }),*/
      isCalendarShown: false
    })
  }

  get activeMonthAndYear() {
    if (!this.props.monthAndYear) return ''
    if (this.props.monthAndYear && this.props.monthAndYear !== '') {
      return moment(this.props.monthAndYear).format('MMM YYYY')
    } else return ''
  }

  handleCalendarDisplay = () => {
    this.isCalendarShown = true
  }

  closeCalendar = () => {
    if (this.isCalendarShown) {
      this.isCalendarShown = false
    }
  }

  onMonthPress = (monthAndYear, isCalendarShown) => {
    const { onChange } = this.props
    if (onChange) {
      onChange(monthAndYear)
    }

    this.closeCalendar()
  }

  // provided by enhanceWithClickOutside HOC
  handleClickOutside = () => {
    if (this.isCalendarShown) {
      this.closeCalendar()
      if (this.props.onBlur) {
        this.props.onBlur()
      }
    }
  }

  render() {
    const { error, disabled, wide, onBlur, ...calendarProps } = this.props

    const wrapperClasses = classNames({
      datepicker__wrapper: true,
      'datepicker__wrapper--error': error,
      'datepicker__wrapper--disabled': disabled
    })

    const datepickerClasses = classNames({
      datepicker: true,
      'datepicker--disabled': disabled
    })

    return (
      <div>
        <div className={wrapperClasses}>
          <input
            readOnly
            disabled={disabled}
            value={this.activeMonthAndYear}
            className={datepickerClasses}
            onFocus={this.handleCalendarDisplay}
            onBlur={() => { }}
          />
          <CalendarIcon inside right noClick gray />
        </div>
        {this.isCalendarShown && (
          <MonthYearCalendar
            activeMonthAndYear={this.activeMonthAndYear}
            onMonthPress={this.onMonthPress}
            {...calendarProps}
          />
        )}
      </div>
    )
  }
}

MonthYearPicker.propTypes = {
  onBlur: PropTypes.func,
  wide: PropTypes.bool,
  error: PropTypes.string,
  disabled: PropTypes.bool,
  monthAndYear: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChange: PropTypes.func
}

export default enhanceWithClickOutside(observer(MonthYearPicker))
